import type { Building3DConfig } from '@/services/3d'

/** Scene center: Miami Opa-Locka Executive Airport (KOPF) */
export const OPA_LOCKA_CENTER: [number, number] = [-80.27843, 25.90699]

/**
 * Initial camera settings pointing at the hangar from a dramatic angle
 */
export const OPA_LOCKA_CAMERA = {
  center: OPA_LOCKA_CENTER,
  zoom: 19.2,
  pitch: 58,
  bearing: -42,
}

/**
 * Single large community hangar at Opa-Locka.
 * Dimensions chosen to realistically fit 8–10 business jets.
 * Position [0,0,0] = scene origin (the OPA_LOCKA_CENTER lat/lng).
 */
export const mockHangar: Building3DConfig = {
  id: 'demo-hangar-alpha',
  name: 'Hangar Alpha',
  width: 220,         // feet east-west
  depth: 180,         // feet north-south
  height: 42,         // feet tall
  wallThickness: 2,
  rotation: 0,        // no rotation — doors face south (+Z)
  position: [0, 0, 0],
  floorColor: '#c8c8c8',
  wallColor: '#b0b8c4',
  templateType: 'single_unit_community',
}
